import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, TrendingUp, Map, Building, Key, Users } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: TrendingUp,
      title: "Investment Sales",
      description:
        "A trusted leader in the acquisition and disposition of income-producing properties for investors, owners and occupiers.",
      image: "https://images.unsplash.com/photo-1724482606633-fa74fe4f5de1?w=600",
    },
    {
      icon: Map,
      title: "Land Sales",
      description:
        "Our land brokers not only understand this specialized niche but have walked down the same path as developers themselves.",
      image: "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=600",
    },
    {
      icon: Building,
      title: "Property Management",
      description:
        "We will create a framework for success by evaluating your property's strengths and challenges.",
      image: "https://images.unsplash.com/photo-1656646424501-06d57009b725?w=600",
    },
    {
      icon: Key,
      title: "Leasing",
      description:
        "Our leasing team works hand in hand with our brokerage and management team to ensure the highest effective rent is achieved with the most favorable rental terms.",
      image: "https://images.unsplash.com/photo-1626178793926-22b28830aa30?w=600",
    },
    {
      icon: Users,
      title: "Tenant Representations",
      description:
        "Our team will work alongside you through each step of the process to secure the ideal space and lease terms for your business.",
      image: "https://images.unsplash.com/photo-1621831337128-35676ca30868?w=600",
    },
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-3">
            Our Services
          </h2>
          <h3 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Honest real estate analytics
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We've created a collaborative platform that encompasses all aspects of the commercial real
            estate continuum to ensure reach and success.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
                      <Icon className="text-white" size={28} />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </h4>
                  <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                  <Button
                    variant="ghost"
                    className="text-blue-600 hover:text-blue-700 p-0 h-auto font-semibold group/btn"
                  >
                    learn more
                    <ArrowRight
                      className="ml-2 transition-transform group-hover/btn:translate-x-1"
                      size={18}
                    />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;